/* eslint-disable react-hooks/rules-of-hooks */
import { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import DataTable from '@/components/features/data-table/DataTable';
import { OnboardingStatusHeader } from '@/components/features/onboarding-status/OnboardingStatusHeader';
import { useVisitListDetails } from '@/services/Onboarding/onboardingService';

/**
 * Reusable DataTable component for various onboarding status views.
 * Determines title, fetch function, and download filename based on the route.
 */
const VisitListRelatedDataTable = ({ startDate, endDate, config }) => {
  const navigate = useNavigate();
  const [totalStoresCount, setTotalStoresCount] = useState(0);

  // Define columns for the DataTable
  const columns = useMemo(
    () => [
      {
        columnKey: 'erpId',
        header: 'ERP ID',
        cellData: ctx => {
          const erpId = ctx.row.original.erpId;
          return erpId ? (
            <span
              style={{
                cursor: 'pointer',
                color: '#66A5E7',
                textDecoration: 'none'
              }}
              onClick={e => {
                console.log('ctx.row.original.erpId', erpId);
                e.stopPropagation(); // Prevent row click from firing
                navigate(`/profile/store/${erpId}`);
              }}>
              {erpId}
            </span>
          ) : (
            '-'
          );
        }
      },
      {
        columnKey: 'error',
        header: 'Error',
        cellData: ctx => config?.title || ''
      }
    ],
    [config?.title, navigate]
  );

  // Calculate total stores count
  const calculateTotalStoresCount = () => {
    return totalStoresCount > 0
      ? totalStoresCount + (totalStoresCount > 1 ? ' Stores' : ' Store')
      : null;
  };

  // Define a fetch function that uses the hook internally
  const fetchFunction = (apiPage, apiPageSize, filtersWithSort) => {
    // // Extract any column filters and pass them as searchParams
    // const { sort, ...searchParamsFromFilters } = filtersWithSort;

    // // Only include search params that have values - create a clean object
    // const cleanSearchParams = {};
    // Object.entries(searchParamsFromFilters).forEach(([key, value]) => {
    //   if (value !== undefined && value !== null && value !== '') {
    //     cleanSearchParams[key] = value;
    //   }
    // });

    // // Ensure config filters is always an object
    // const configFilters = config?.filters || {};

    // // Create a clean copy of the configFilters, removing any empty values
    // const cleanConfigFilters = {};
    // Object.entries(configFilters).forEach(([key, value]) => {
    //   if (
    //     value === true ||
    //     (value !== undefined && value !== null && value !== '')
    //   ) {
    //     cleanConfigFilters[key] = value;
    //   }
    // });

    return useVisitListDetails(
      apiPage,
      apiPageSize,
      // cleanConfigFilters,
      filtersWithSort,
      startDate,
      endDate
    );
  };

  return (
    <DataTable
      tableHeader={<OnboardingStatusHeader title={config?.title} />}
      subHeader={calculateTotalStoresCount()}
      columns={columns}
      isDark={true}
      showColumnFilters={true}
      onSettingsClicked={() => alert('Settings clicked')}
      selection='multiple'
      idField='erpId'
      pageSize={10}
      enableSorting={true}
      downloadFileName={config?.downloadFileName}
      setTotalStoresCount={setTotalStoresCount}
      fetchFunction={fetchFunction}
    />
  );
};

export default VisitListRelatedDataTable;
